var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"90%"},attrs:{"src":_vm.host+_vm.qr}})])
}
var staticRenderFns = []

export { render, staticRenderFns }